export default {
  UserPoolId: process.env.COGNITO_USER_POOL_ID,
  ClientId: process.env.APPLICATION_CLIENT_ID
}
